import React, { createContext, useContext, useState, useCallback, ReactNode } from "react"
import { Toast, type ToastData, type ToastType } from "@/components/Molecules/Toast/Toast"

interface ToastContextType {
  show: (message: string, type?: ToastType, title?: string) => void
  success: (message: string, title?: string) => void
  danger: (message: string, title?: string) => void
}

const ToastContext = createContext<ToastContextType | undefined>(undefined)

export const ToastProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [toasts, setToasts] = useState<ToastData[]>([])

  const remove = useCallback((id: string) => {
    setToasts((prev) => prev.filter((t) => t.id !== id))
  }, [])

  const show = useCallback((message: string, type: ToastType = "default", title?: string) => {
    const id = Math.random().toString(36).substr(2, 9)
    setToasts((prev) => [...prev, { id, type, message, title }])
  }, [])

  // Helpers específicos
  const success = (msg: string, title?: string) => show(msg, "success", title)
  const danger = (msg: string, title?: string) => show(msg, "danger", title)

  return (
    <ToastContext.Provider value={{ show, success, danger }}>
      {children}
      {/* Container de Toasts fixo na tela */}
      <div className="pointer-events-none fixed right-5 top-5 z-[9999] flex flex-col gap-3">
        {toasts.map((toast) => (
          <Toast
            key={toast.id}
            {...toast}
            onClose={remove}
          />
        ))}
      </div>
    </ToastContext.Provider>
  )
}

export const useToast = () => {
  const context = useContext(ToastContext)
  if (!context) throw new Error("useToast deve ser usado dentro de um ToastProvider")
  return context
}
